// extracted by mini-css-extract-plugin
export default {"input-password":"input-password","inputPassword":"input-password","input":"input","showPassword":"showPassword","checkbox":"checkbox"};